import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import postal from 'postal';
import { useSpring, animated } from 'react-spring';
import { scroller } from 'react-scroll';
import ErrorBoundary from '../../../shared/error-boundary';
import Form from './contact-form-components/form';

const Container = styled(animated.div)`
  overflow: hidden;
`;

const showTopic = {
  channel: 'micro-profile.commands',
  topic: 'present-lead-capture-form',
};
const name = 'lead-capture-form';

export default function AnimatedContactForm(props) {
  const {
    wireTitle, wireUrl,
  } = props;
  const [is1stScroll, setIs1stScroll] = React.useState(true);
  const [hasScrolled, setHasScrolled] = React.useState(false);
  const [show, setShow] = React.useState(false);

  const present = React.useCallback(() => {
    if (window.Livewire.currentUser) {
      setShow(true);
      return;
    }
    postal.publish({
      channel: 'commands.sign-up',
      topic: 'present',
      data: {
        campaignHeader: `To access &ldquo;<em>${wireTitle}</em>&rdquo; register free today`,
        redirectTo: wireUrl,
      },
    });
  }, [wireTitle, wireUrl]);

  const scrollToForm = React.useCallback(() => {
    if (!show || hasScrolled || !is1stScroll) {
      return;
    }

    scroller.scrollTo(name, {
      offset: -150,
      duration: 1500,
      smooth: 'easeInOutQuint',
    });

    setHasScrolled(true);
    setIs1stScroll(false);
  }, [show, hasScrolled, is1stScroll]);

  const { height } = useSpring({ height: show ? 'auto' : 0, onRest: scrollToForm });

  React.useEffect(() => {
    postal.unsubscribe(showTopic);
    postal.subscribe({ ...showTopic, callback: present });
  }, [present]);

  return (
    <ErrorBoundary>
      <Container style={{ height }}>
        <Form {...props} name={name} />
      </Container>
    </ErrorBoundary>
  );
}

AnimatedContactForm.propTypes = {
  wireTitle: PropTypes.string.isRequired,
  wireUrl: PropTypes.string.isRequired,
};
